module.exports = __webpack_public_path__ + "assets/img/rz5.bff8c244.png";